import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'scrolltofixed';
import 'slick-carousel';

import OneSwatches from '@/modules/module-oneSwatches';
import OneZoom from '@/modules/module-oneZoom';
import OneDrawer from '@/modules/module-oneDrawer';
import OneTabSystem from '@/modules/module-oneTabSystem';
import OneVideo from '@/modules/module-oneVideo';
import OneRecentlyViewed from '@/modules/module-oneRecentlyViewed';
import OneQuickBuy from '@/modules/module-oneQuickBuy';

import '../../styles/modules/oneSizeChart.scss';

export default Backbone.View.extend({
    
    initialize: function(opts){
        
        console.log('init PDP');
        
        var self = this,
            selectors = {
                addToCart: '[data-add-to-cart]',
                addToCartText: '[data-add-to-cart-text]',
                comparePrice: '[data-compare-price]',
                comparePriceText: '[data-compare-text]',
                originalSelectorId: '[data-product-select]',
                priceWrapper: '[data-price-wrapper]',
                productFeaturedImage: '[data-product-featured-image]',
                productJson: '[data-product-json]',
                productPrice: '[data-product-price]',
                productThumbs: '[data-product-single-thumbnail]',
                singleOptionSelector: '[data-single-option-selector]'
            };

        // $content is .product-detail-container
        self.$content = self.$el;
        self.$body = $('body');
        self.$productDetailContainer = self.$content.find('.product-detail-container');

        self.$mediaCore = self.$content.find('.product-media-core-wrapper');
        self.$media = self.$content.find('.product-media');
        self.$mainImage = self.$media.find('#ProductMediaImages');
        self.$thumbImage = self.$media.find('#ProductMediaThumbs');
        self.$mediaSlider = self.$mainImage.find('.images-wrapper');
        self.$thumbSlider = self.$thumbImage.find('.images-wrapper');

        self.$productCore = self.$content.find('.product-core');
        self.$socialIcons = self.$productCore.find('.one-social');
        self.productJSON = self.$content.find(selectors.productJson).length ? JSON.parse(self.$content.find(selectors.productJson).html()) : false;
        self.isGiftCard = self.$productDetailContainer.hasClass('gift-card');
        self.productQty = self.$content.find('.product-qty-container');
        self.$productExtra = self.$content.find('.product-extra');
    
        self.$recentlyViewed = self.$content.find('.recently-viewed .items');
        
        // Product Modules
        self.$contentModule = self.$content.find('.product-module.content-ingredients');
        self.$pairWithModule = self.$content.find('.product-module.pair-with');
        self.$pairWithQuickbuy = false;

        // Features
        self.enableMiniCore = true;
        self.isScrollingLayout = self.$content.data('layout') == 'scrolling' ? true : false;
        self.isScrollingGrid = self.$content.hasClass('scrolling-grid');
        self.isSliderLayout = self.$content.data('layout') == 'slider' ? true : false;
        self.isQuickshopLayout = self.$content.data('layout') == 'quickshop' ? true : false;
        
        self.productMedia();
        self.productCore();
        
        if (!self.isQuickshopLayout) {
            self.social();
        } 
        
        if (!self.isGiftCard && !self.isQuickshopLayout) {
            self.zoom();
            self.video();
            // self.sizeChart();
            self.accordionsAndTabs();
            self.recentlyViewed();
        }

        if (self.$contentModule.length > 0) {
            self.contentModuleSlideInText();
            self.contentModuleAccordion();
        }

        if (self.$pairWithModule.length > 0) {
            self.pairWithQuickbuy();
            self.pairWithSlider();
        }
    },

    events: {
        'submit .add-to-cart-form' : 'addedToCartMessage'
    },
    
    swatches: function(){
        var self = this;
        // Init Shopify option selector
        // Option init and Swatch init needed to be separated
        var productSignleSelectorId = 'productSelect';
        if (self.isQuickshopLayout) {
            productSignleSelectorId = self.$productCore.find('.product-single__variants').attr('id')
        }
        
        // Init product variant selection and swatches
        new Shopify.OptionSelectors(productSignleSelectorId, {
            product: self.productJSON,
            onVariantSelected: self.isGiftCard ? function(variant, selector){} : ShopifyAPI.selectCallback,
            enableHistoryState: self.isQuickshopLayout ? false : true
        });
        OneSwatches.init({ 
            el: self.$mediaCore, 
            preSelect: true, 
            product: self.productJSON, 
            disableImageUpdate: true 
        });
        console.log("cccccccccccccccccccccccccccccccc");
    },
    
    ajaxCart: function(){
        var self = this;
        $('.add-to-cart-form').off('submit');
        ajaxCart.init({
            formSelector: '.add-to-cart-form',
            addToCartSelector: '.add-to-cart-btn',
            cartContainer: '.minicart-container',
            cartCountSelector: '.minicart-count',
            cartCostSelector: '.minicart-cost',
            moneyFormat: theme.moneyFormat
        });
    },
    
    productMedia: function(){
        var self = this;
        var events = {
            'click .image-thumbnail' : function(e){
                e.preventDefault();
                // var $curr = $(e.currentTarget);
                // var index = $curr.data('index') - 1;
                // if (self.$media.hasClass('initialized')) {
                //     self.$mediaSlider.slick('slickGoTo',index);
                // }
            }
        }

        self.$mediaSlider.on('init', function(event, slick, direction){
            self.$media.addClass('initialized');
            $(window).resize();
        });
        self.$thumbSlider.on('init', function(event, slick, direction){
            if (slick.slideCount <= slick.options.slidesToShow) {
                self.$thumbSlider.parent().addClass('no-transform');
            }
        });

        self.$mediaSlider.slick({
            arrows: true,
            infinite: false,
            speed: 600,
            initialSlide: 0,
            slidesToShow: 1,
            fade: true,
            asNavFor: self.$thumbSlider,
            rows: 0,
            responsive: [
                {
                    breakpoint: ORW.responsiveSizes.large,
                    settings: {
                        arrows: true,
                        infinite: true,
                        fade: false,
                        centerMode: true,
                        centerPadding: '10%'
                    }
                }
            ]
        });

        // Sidebar Thumbnail
        self.$thumbSlider.slick({
            infinite: false,
            speed: 600,
            slidesToShow: 8,
            slidesToScroll: 1,
            arrows: true,
            vertical: true,
            asNavFor: self.$mediaSlider,
            focusOnSelect: true,
            rows: 0
        });
        self.slickCoreFix(self.$mediaSlider);
        self.slickCoreFix(self.$thumbSlider);
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    slickCoreFix: function(slick_instance){
        /*
            Yang@1R To fix a slick bug when using `asNavFor` along with slick filter
            PLEASE SEE https://github.com/kenwheeler/slick/issues/1043
        */
        if (!slick_instance) {
            return false;
        }
        var newReinit = function reinitOverride () {
            this._overriddenReinit();
            this.$slides.each(function(index, element) { $(element).attr('data-slick-index', index); });
        };
        slick_instance.slick('getSlick')._overriddenReinit = slick_instance.slick('getSlick').reinit;
        slick_instance.slick('getSlick').reinit = newReinit;
        return slick_instance;
    },
    
    productCore: function(){
        var self = this;
        self.swatches();
        self.ajaxCart();
        self.productQuantity();
        
        if (!self.isQuickshopLayout) {
            if (self.enableMiniCore) {
                self.productCoreMini();
            }
            
            if (self.isScrollingLayout && !self.isScrollingGrid) {
                self.productCoreScrollFixing()
            }
        }
    },
    
    productQuantity: function(){
        var self = this;
        var $input = self.productQty.find('.qty-input[type=number]');
        var qty = $input.data('value');

        var events = {
            'click .product-qty-container .qty-btn' : function(e){
                e.preventDefault();
                var $curr = $(e.currentTarget);
                if($curr.hasClass('plus')){
                    $input[0].stepUp()
                } else {
                    $input[0].stepDown();
                }
                $input.attr('value', $input.val())
            }
        }

        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },

    addedToCartMessage: function(e) {
		var self = this;
		var $addToCartButton = $(e.target).find('.add-to-cart-btn');

		$addToCartButton.addClass('added-to-cart');
		setTimeout(() => {
			$addToCartButton.removeClass('added-to-cart');
		  }, 2000);
	},

    productCoreScrollFixing: function(){
        var self = this;
        var init = function($elm){
            $elm.scrollToFixed({
                zIndex: 2,
                removeOffsets: true,
                dontSetWidth: true,
                marginTop: function(){
                    return $('header.site-header').outerHeight() + 50;
                },
                limit: function() {
                    var limit = $('.scrolling-fix-stopper').offset().top - $(this).height();
                    return limit;
                }
            });
        }
        self.$scrollFixingCore = self.$productCore.find('.product-core-inner');
        // Not available on Mobile.
        ORW.utilities.mediaCheck(function () {
            init(self.$scrollFixingCore);
        }, function () {
            self.$scrollFixingCore.trigger('detach.ScrollToFixed');
        });
    },
    
    productCoreMini: function(){
        var self = this;
        var init = function($elm){
            console.log('init minicore');
            var limit = $('.footer-parallax').offset().top - $elm.height();
            $elm.scrollToFixed({
                zIndex: 2,
                removeOffsets: true,
                dontSetWidth: true,
                triggerAtBottom: true,
                limit: limit,
                fixed: function(){
                    $(this).addClass('fixed-core');
                },
                unfixed: function() {
                    $(this).removeClass('fixed-core');
                }
            });
        }
        self.$miniCore = self.$productCore.find('.block-core');
        // Under scrolling layout, miniCore will only available on Small screen.
        ORW.utilities.mediaCheck(function () {
            self.$miniCore.trigger('detach.ScrollToFixed');
            // Uncomment to include minicore on desktop
            // if (!self.isScrollingLayout || self.isScrollingGrid) {
            //     init(self.$miniCore);
            // }
        }, function () {
            self.$miniCore.trigger('detach.ScrollToFixed');
            init(self.$miniCore);
        });
    },
    
    social: function(){
        var self = this;
        var events = {
            'click .share-title':function(e){
                self.$socialIcons.toggleClass('active');
            },
        };
        
        // Update and delegate adding events
        _.extend(self.events, events);
        self.delegateEvents();
    },
    
    zoom: function(){
        var self = this;
        OneZoom.init({
            el: self.$media,
            mainImage: self.$mainImage,
            thumbImage: self.$thumbImage
        });
    },
    
    video: function(){
        var self = this;
        var $videos = self.$content.find('.video-wrapper:not(.always-visible)');
        var $videosAlwaysVisible = self.$content.find('.video-wrapper.always-visible');
        
        OneVideo.init({
            el: $videos,
            isResponsive: false,
            bgVideo: true,
            autoplay: false,
            hasSound: true,
            showVideoOnPause: true
        });

        OneVideo.init({
            el: $videosAlwaysVisible,
            isResponsive: false,
            bgVideo: false,
            alwaysVisible: true,
            autoplay: false,
            hasSound: true,
            showVideoOnPause: true
        });
    },
    
    accordionsAndTabs: function(){
        var self = this;
        OneTabSystem.init({
            el: self.$content
        });
    },
    
    sizeChart: function() {
        var self = this;
        var sizeChartHtml = $('#SizeChartModal')[0].outerHTML;
        $('#SizeChartModal').remove();
        var drawerCtl = OneDrawer.init({
            drawerContent: sizeChartHtml,
            drawerModalId: 'SizeChartDrawerModal',
            triggerEvent: 'click',
            triggerElem: '.size-chart-trigger',
            initCallback: function(){
                OneTabSystem.init({
                    el: $('#SizeChartModal')
                });
            },
            openCallback: function(){},
            closeCallback: function(){},
            events: {}
        });
    },

    recentlyViewed: function() {

        let self = this;

        OneRecentlyViewed.init({
            el: self.$recentlyViewed
        });
    },

    contentModuleSlideInText: function() {
        // Add class for slide in animation
        var self = this;
        var $animatedBlocks = self.$contentModule.find('.block-section .content-block');
        var modulePosition = self.$contentModule.offset().top - 50;
        var reversedBlocks = $animatedBlocks.get().reverse();
        
        var animateBlocks = function() {
            if($(this).scrollTop() >= modulePosition) { 
                var timer = 500;
                $(reversedBlocks).each(function() {
                    setTimeout(() => {
                        $(this).addClass('animate');
                      }, timer);
                    timer += 500;
                })
                $(window).off('scroll', animateBlocks);
            }
        }

        $(window).on('scroll', animateBlocks);
    },

    contentModuleAccordion: function() {
        var self = this;

        var $accordionSystem = self.$contentModule.find('.mobile-accordion');

        ORW.utilities.mediaCheck(function () {
            // No accordion on desktop
            $accordionSystem.removeClass('tab-accordion-system accordion-container');
        }, function () {
            // Accordion on mobile
            $accordionSystem.addClass('tab-accordion-system accordion-container');
        })
    },

    pairWithQuickbuy: function() {
        var self = this;

        self.$pairWithQuickbuy && self.$pairWithQuickbuy.destroy();
        self.$pairWithQuickbuy = OneQuickBuy.init({ el: self.$pairWithModule });
    },

    pairWithSlider: function() {
        var self = this;

        var $productSlider = self.$pairWithModule.find('.slick');

        // Product cards slider
        $productSlider.slick({
            dots: false,
            infinite: false,
            speed: 600,
            slidesToShow: 2,
            arrows: true,
            rows: 0,
            responsive: [
                {
                    breakpoint: ORW.responsiveSizes.large,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    },
    
    destroy: function() {
        var self = this;
        self.undelegateEvents();
    },
    
    responsive: function () {
        var self = this;
        ORW.utilities.mediaCheck(function () {
            // Desktop actions
        }, function () {
            // Mobile actions
        })
    },
    
    isMobile: function () {
        if ( ORW.responsive == 'small') {
            return true;
        }
        return false;
    }
});